const Make = require("../make/Make");
const {CAR_CATEGORY, CAR_UNIT, KW_TP_METRIC_HP} = require('./CarConstant');
const Consumption = require("../consumption/Consumption");
const QuantityOption = require("../rentOption/QuantityOption");

class CarModel {

    constructor({
                    id = '',
                    name = '',
                    highlightImage = '',
                    exteriorImage = [],
                    interiorImage = [],
                    drivePower = 0,
                    driveTorque = 0,
                    acceleration0To100 = 0,
                    engineType = '',
                    basePrice = 0,
                    monthlyBasePrice = 0,
                    makeID = null,
                    make = null,
                    rentOption = QuantityOption.fromFirestore(QuantityOption.DEFAULT_OPTION),
                    category = [],
                    consumption,
                    immediatelyAvailable = false,
                    version= 1,
                } = {}) {

        this.id = id;
        this.name = name;
        this.highlightImage = highlightImage;
        this.exteriorImage = exteriorImage;
        this.interiorImage = interiorImage;
        this.drivePower = drivePower;
        this.driveTorque = driveTorque;
        this.acceleration0To100 = acceleration0To100;
        this.engineType = engineType;
        this.basePrice = basePrice;
        this.monthlyBasePrice = monthlyBasePrice;
        this.makeID = makeID;
        this.make = make;
        this.rentOption = rentOption;
        this.category = Array.isArray(category) ? category.filter((c) => CAR_CATEGORY[c]) : [];
        this.consumption = new Consumption(consumption);
        this.immediatelyAvailable = immediatelyAvailable;
        this.version = version;
    }

    get monthlyPrice() {
        let price = this.monthlyBasePrice;
        Object.values(this.rentOption).forEach((option) => {
            price += Number.isNaN(option.addPrice) ? 0 : option.addPrice(this.monthlyBasePrice)
        })
        return price
    }

    get monthlyBeautifyPrice() {
        return CarModel.beautifulPrice(this.monthlyPrice);
    }

    get drivePowerPS() {
        return Math.round(this.drivePower * KW_TP_METRIC_HP);
    }

    static get CAR_CATEGORY() {
        return CAR_CATEGORY
    };

    static get CAR_UNIT() {
        return CAR_UNIT
    };

    static beautifulPrice(price = 0){
        if(price < 0){
            throw new Error('negative price')
        }

        if(price % 10 === 0){
            return price - 1
        }
        return Math.floor(price / 10 + 1) * 10 - 1
    }

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating CarModel with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        const rentOption = {}

        Object.keys(this.rentOption).forEach((key) => {
            if (this.rentOption[key].toFirestore) {
                rentOption[key] = this.rentOption[key].toFirestore()
            }
        })

        return {
            id: this.id,
            name: this.name,
            highlightImage: this.highlightImage,
            exteriorImage: this.exteriorImage,
            interiorImage: this.interiorImage,
            drivePower: this.drivePower,
            driveTorque: this.driveTorque,
            acceleration0To100: this.acceleration0To100,
            engineType: this.engineType,
            basePrice: this.basePrice,
            monthlyBasePrice: this.monthlyBasePrice,
            makeID: this.makeID,
            rentOption: rentOption,
            category: this.category,
            consumption: this.consumption.toFirestore ? this.consumption.toFirestore() : null,
            immediatelyAvailable: this.immediatelyAvailable,
        }
    }

    static parseFirestore(model, id = '', make = Make.PRIME_MAKE) {
        return new CarModel({
            ...model,
            rentOption: model.rentOption ? QuantityOption.fromFirestore(model.rentOption) : {},
            make: make[model.makeID] || null,
            id: id
        })
    }

    static fromFirestore(fsSnap, make = Make.PRIME_MAKE) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = CarModel.parseFirestore(fsSnap[key], key, make)
                }
            });
        }
        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = CarModel;